import { useMemo, useRef } from "react";
import L from "leaflet";
import { Marker as LeafletMarker } from "react-leaflet";

// import markerSelected from "../../../assets/icons/map/markerSelected.svg";
import markerIcon from "../../../assets/icons/map/markerNotSelected.svg";

const markerLeafletIcon = new L.Icon({
  iconUrl: markerIcon,
  // marker icon size is w: 24, h: 29
  iconAnchor: [12, 28],
});

const Marker = ({
  isDraggable,
  position,
  setPosition,
  icon,
  onClick,
  opacity,
  children,
}) => {
  const markerRef = useRef(null);

  const eventHandlers = useMemo(
    () => ({
      dragend() {
        const marker = markerRef.current;
        if (marker != null) {
          setPosition?.(marker.getLatLng());
        }
      },
      ...(typeof onClick === "function"
        ? {
            click: onClick,
          }
        : {}),
    }),
    [onClick, setPosition],
  );

  return (
    <LeafletMarker
      ref={markerRef}
      icon={icon ?? markerLeafletIcon}
      eventHandlers={eventHandlers}
      draggable={isDraggable}
      position={position}
      opacity={opacity}
      riseOnHover
    >
      {children}
    </LeafletMarker>
  );
};

export default Marker;
